import React from 'react'
import { Menu, MenuItem, Button } from '@material-ui/core'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { makeStyles, Theme } from '@material-ui/core/styles'
import FilterIcon from '../../assets/icons/filter.png'

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    fontWeight: 'inherit',
    fontSize: 'inherit',
    padding: 0
  }
}))

type SelectInputProps = {
  value: string
  label: string
  options: { value: any; label: string }[]
  selectHandler: (select: string) => void
}

const SelectInputTableHead: React.FC<SelectInputProps> = props => {
  const { value, label, selectHandler, options } = props
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleBottunClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuItemClick = (event: React.MouseEvent<HTMLElement>, value: string) => {
    selectHandler(String(value))
    setAnchorEl(null)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <div>
      <Button
        className={classes.button}
        aria-controls="filter-menu"
        aria-haspopup="true"
        onClick={handleBottunClick}
        color={value ? 'primary' : 'default'}
      >
        {label}
        {value ? (
          <img
            src={FilterIcon}
            alt="filter img"
            style={{ width: '16px', height: '16px', paddingLeft: 5 }}
          />
        ) : (
          <ArrowDropDownIcon />
        )}
      </Button>
      <Menu
        id="filter-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {options.map(option => (
          <MenuItem
            key={option.value}
            value={option.value}
            selected={option.value === value}
            onClick={event => handleMenuItemClick(event, option.value)}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}

export default SelectInputTableHead
